'use client'

import Image from 'next/image'
import { Link } from '@/navigation'
import { useTranslations } from 'next-intl'

import image from '../../assets/505-image.svg'

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const t = useTranslations('ErrorPage')
  return (
    <div className="container mx-auto my-[60px] flex w-full justify-center rounded-xl bg-white">
      <div className=" flex w-full max-w-[600px] flex-col items-center py-[5vw] text-center">
        <Image src={image} alt="not found image" className="mb-12" priority />
        <h3 className=" mb-4 text-primary-darkest">{t('title')}</h3>
        <p className="mb-4">{t('description')}</p>
        <div className="flex flex-row gap-4">
          <button className="btn-primary text-[15px]" onClick={reset}>
            {t('tryAgain')}
          </button>
          <Link className="btn-primary-outlined w-fit text-[15px]" href="/">
            {t('goToMain')}
          </Link>
        </div>
      </div>
    </div>
  )
}
